import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { validate_id, allow_num } from "@/utils/validations";
import { useToast } from '@/components/Toast/useToast';

export default {
    name: 'AddressForm',
    setup() {
        const { showSuccess, showError } = useToast();
        
        return {
            showSuccess,
            showError
        };
    },
    data() {
        return {
            form: {
                id_number: '',
                error: ''
            }
        };
    },
    emits: ['service_status_complete'],
    methods: {
        allow_num(event) {
            this.id_number = allow_num(event);
        },
        submit_id() {
            if (!this.form.id_number.trim()) {
                this.showError('Error', 'ID Number is required');
                return false;
            }

            if (!validate_id(this.form.id_number)) {
                this.showError('Error', 'Invalid ID Number');
                return false;
            }
            this.address_match_api();
        },
        address_match_api() {
            const TOKEN = localStorage.getItem('token');
            const ADDRESS_MATCH_API = `${API_BASE_URL}/verify_api/instant_verify_api/address_match/`;

            this.form.error = '';

            $.ajax({
                url: ADDRESS_MATCH_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    id_number: this.form.id_number
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                },
                success: () => {
                    Swal.close();
                    this.showSuccess('Successful', 'Address Matched Successfully', 3000);
                    this.$emit('service_status_complete');
                    this.form.id_number = ''
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Something went wrong!';

                    if (error.responseJSON && error.responseJSON.message) {
                        error_message = error.responseJSON.message;
                    }

                    this.showError('Error', error_message);
                }
            });
        }
    },
    mounted() {
        if (!validateToken(this.$router)) {
            return;
        }
    }
};
